import { Box } from "@material-ui/core";
import * as React from "react";
import { TimeSvg } from "../../../../../../assets/icons/custom-svg-components/CompanySvgCollection";
import { Utils } from "../../../../../../services/utils";

interface EventItemDateTimeProps {
  date: Date;
}

const EventItemDateTime: React.FC<EventItemDateTimeProps> = ({ date }) => {
  return (
    <>
      <Box style={{ marginLeft: "0.3125rem" }} />
      <TimeSvg /> {Utils.formatToLocalTime(date)}
    </>
  );
};

export default EventItemDateTime;
